/**
 * Converts exact mention count to range-based display text
 * @param count - The exact number of mentions
 * @returns Range-based text for display
 */
export const mentionCountRanges = (count: number = 0): string => {
  if (count === 0) return '0 posts';
  if (count <= 4) return 'less than 5 posts';
  if (count <= 10) return '5 to 10 posts';
  return '10 or more posts';
};
